import {IconButton} from '@dropbox/dig-components/buttons';
import {Toggletip} from '@dropbox/dig-components/tooltips';
import {Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {InfoLine, SettingsLine} from '@dropbox/dig-icons/assets';
import {isLexicalValueEmpty} from 'components/DSYS/editor/utils';
import {RichTextArea} from 'components/DSYS/RichTextArea';
import {useIsTemplateMode} from 'plugins/enhancedHeadings/RoleContext';
import {useState} from 'react';

import {TableCellSettingsModal} from './TableCellSettingsModal';

export const TableCellComponent = ({cellId, guidance}: {cellId: string; guidance: string}) => {
  const isTemplateMode = useIsTemplateMode();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Template mode: show gear icon for settings
  if (isTemplateMode) {
    return (
      <>
        <IconButton size="small" variant="opacity" onClick={() => setIsModalOpen(true)}>
          <UIIcon src={SettingsLine} />
        </IconButton>
        {isModalOpen && (
          <TableCellSettingsModal
            cellId={cellId}
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        )}
      </>
    );
  }

  // Document mode: show guidance tooltip if we have guidance
  if (!isLexicalValueEmpty(guidance)) {
    return (
      <Toggletip
        title={
          <Box style={{maxWidth: 'min(480px, calc(100vw - 48px))'}} paddingY="8">
            <RichTextArea value={guidance} editable={false} />
          </Box>
        }
        placement="top-end"
        src={InfoLine}
      />
    );
  }

  // No guidance in document mode
  return null;
};
